import { css } from '@emotion/react';
import { formatPrice } from 'utils/utils';
import { FlexStyle } from 'styles/FlexStyles';
import { theme } from 'styles/theme';
import { usePrice } from 'hooks/usePrice';

export const PriceSummary = ({ total, isVat }: { total: number; isVat?: boolean }) => {
	const { withVAT, withoutVAT, VAT } = usePrice({ price: total });

	return (
		<div css={FlexStyle({ directionColumn: true })}>
			<div>
				<strong>
					{formatPrice(isVat ? withVAT : withoutVAT)} {isVat && 's DPH'}
				</strong>
			</div>

			{isVat && (
				<div
					css={css`
						font-size: 13px;
						color: ${theme.color.text['300']};
					`}
				>
					{formatPrice(withoutVAT)} bez DPH
					<br />Z toho DPH {formatPrice(VAT)}
				</div>
			)}
		</div>
	);
};
